/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Passkey_UnsupportedInputs */

const en_signin_passkey_unsupported = /** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser cannot use passkeys`)
};

/** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */
const ar_signin_passkey_unsupported = en_signin_passkey_unsupported;

/** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */
const he_signin_passkey_unsupported = en_signin_passkey_unsupported;

/** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */
const ur_signin_passkey_unsupported = en_signin_passkey_unsupported;

/** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */
const es_signin_passkey_unsupported = en_signin_passkey_unsupported;

/** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */
const fr_signin_passkey_unsupported = en_signin_passkey_unsupported;

/** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */
const de_signin_passkey_unsupported = en_signin_passkey_unsupported;

/** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */
const pt_signin_passkey_unsupported = en_signin_passkey_unsupported;

/** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */
const hi_signin_passkey_unsupported = en_signin_passkey_unsupported;

/** @type {(inputs: Signin_Passkey_UnsupportedInputs) => LocalizedString} */
const bn_signin_passkey_unsupported = en_signin_passkey_unsupported;

/**
* | output |
* | --- |
* | "This browser cannot use passkeys" |
*
* @param {Signin_Passkey_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_passkey_unsupported = /** @type {((inputs?: Signin_Passkey_UnsupportedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Passkey_UnsupportedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_passkey_unsupported(inputs)
	if (locale === "he") return he_signin_passkey_unsupported(inputs)
	if (locale === "ur") return ur_signin_passkey_unsupported(inputs)
	if (locale === "es") return es_signin_passkey_unsupported(inputs)
	if (locale === "fr") return fr_signin_passkey_unsupported(inputs)
	if (locale === "de") return de_signin_passkey_unsupported(inputs)
	if (locale === "pt") return pt_signin_passkey_unsupported(inputs)
	if (locale === "hi") return hi_signin_passkey_unsupported(inputs)
	if (locale === "bn") return bn_signin_passkey_unsupported(inputs)
	return /** @type {LocalizedString} */ ("This browser cannot use passkeys")
});